/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { z } from "zod";
import { Description } from "@nordcloud/gnui";

export function ValidationMessagePrice() {
  return <Description>Price is not valid.</Description>;
}

const regex = /^[0-9]*([.][0-9]*)?$/;
export const isValidDecimalSchema = z.string().regex(regex).nullable();
export const isValidNonNegativeValSchema = z
  .number()
  .max(99999999)
  .nonnegative()
  .nullable();

export const isValidPrice = (price: string) => {
  if (price === "") {
    return true;
  }

  return (
    isValidDecimalSchema.safeParse(price).success &&
    isValidNonNegativeValSchema.safeParse(parseFloat(price)).success
  );
};

export const isBiggerThan = (price: string, compare: string) => {
  if (!isValidPrice(price)) return false;

  return z
    .number()
    .refine((val) => val >= parseFloat(compare))
    .safeParse(parseFloat(price)).success;
};

export const isSmallerThan = (price: string, compare: string) => {
  if (!isValidPrice(price)) return false;

  return z
    .number()
    .refine((val) => val <= parseFloat(compare))
    .safeParse(parseFloat(price)).success;
};

export const isWithinRange = (
  price: string,
  compareFirst: string,
  compareSecond: string
) => {
  if (!isValidPrice(price)) return false;

  return (
    Number(price) >= Number(compareFirst) ===
    Number(price) <= Number(compareSecond)
  );
};
